<template>
	<div class="pt160 text-center">
		<p class="text-danger p1">恭喜您成功提交报名信息!</p>
		<p class="line30">请扫码添加教练微信(备注:报名XX课程XX期</p>
		<p class="line30">月份助教)，等待入群参与助教岗前培训事宜</p>
		<div class="mt56">
			<img v-show="$route.query.bid==1" src="../../../assets/ta_askfor_result-qrimg.jpg" alt="" />
			<img v-show="$route.query.bid==2"  src="../../../assets/ta_askfor_result-qrimg2.png" alt="" />
			<p class="qr-span">(长按识别或扫描上方二维码添加)</p>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				qrImg: ''
			}
		},
	}
</script>
<style lang="scss" scoped>
	.pt160{
		padding-top: 160px;
	}
	.mt56{
		margin-top: 56px;
		img{
			max-width: 426px;
			width: 426px;
			background: #ccc;
		}
		.qr-span{
			font-size: 28px;
			color: #999;
		}
	}
	.p1{
		font-size: 32px;
	}
	.line30{
		line-height: 40px;
		color: #666;
	}
	.text-danger{
		color: #EB5032;
		margin-bottom: 20px;
	}
</style>